module.exports = __webpack_public_path__ + "static/img/content1.cd298587.png";